export const TitleFont = "DM Sans, sans-serif"
export const NumberFont = "Space Grotesk, monospace"
